// removed by extract-text-webpack-plugin
module.exports = {"containerDetailsClass":"styles__containerDetailsClass___1tsn2"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/NewInterfaceOnline/components/Description/styles.css
// module id = 2868
// module chunks = 0